import AttachmentsList from '@app/components/AttachmentsList'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import {
  actionCreators,
  IDevelopmentClientViewState,
} from '../modules/developmentClientDetail'

type IComponentProps = IDevelopmentClientViewState &
  RouteComponentProps<{ clientSlug: string }> &
  typeof actionCreators

class DevelopmentClientAttachments extends React.PureComponent<
  IComponentProps
> {
  public render() {
    if (!this.props.item) {
      return null
    }

    return (
      <div>
        <div className='mx-2'>
          <AttachmentsList
            attachments={this.props.item.attachments}
            onChange={this.props.setAttachments}
          />
        </div>
      </div>
    )
  }
}

export default withRouter(DevelopmentClientAttachments)
